import React from 'react'
import { assoc, compose, path, pick } from 'ramda'

import Editable from '../../packages/kiti/components/form/Editable'
import { serviceOrdersClient } from '../../utils/apollo/api'
import { useNotification } from '@btime/react-messager'
import { gql, useMutation } from '@apollo/client'
import { useSessionPermission } from '@btime/react-session'

const MUTATION = gql`
  mutation UpsertDynamicServiceOrder($input: DynamicServiceOrderInput) {
    upsertDynamicServiceOrder(input: $input) {
      id
    }
  }
`

const cleanRecord = item =>
  compose(pick(['id', 'name', `checklistId`]), assoc(`checklistId`, item?.checklist?.id))(item)

const cleanRequest = (field, value, record) => {
  const clearedRecord = cleanRecord(record)

  switch (field) {
    case 'checklist':
      return { ...clearedRecord, checklistId: value?.id }
    default:
      return { ...clearedRecord, [field]: value }
  }
}

const EditableDynamicServiceOrders = ({ record, field, children, ...props }) => {
  const canEdit = useSessionPermission('editDynamicServiceOrder')
  const notify = useNotification()
  const [request, { loading }] = useMutation(MUTATION, {
    refetchQueries: ['DynamicServiceOrders'],
    client: serviceOrdersClient
  })

  const handleRequest = value => {
    const params = {
      variables: {
        input: cleanRequest(field, value, record)
      }
    }
    return request(params).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: 'Ocorreu um erro ao salvar!', message: path(['errors', 0, 'message'], resp) })
      }
    })
  }

  return (
    <Editable value={record[field]} onSubmit={handleRequest} loading={loading} disabled={!canEdit} {...props}>
      {children}
    </Editable>
  )
}

export default EditableDynamicServiceOrders
